import store from '../store';
import airgram from '../airgram';

function blobToDataURL(blob, callback) {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.onload = e => {
      resolve(e.target.result);
    };

    reader.readAsDataURL(blob);
  });
}

export default {
  async downloadFile({fileId}) {
    let file = store.stores.files.files.find(file => file.id === fileId);

    if(!file) {
      file = await airgram.api.downloadFile({
        fileId,
        priority: 32,
        offset: 0,
        limit: 0,
        synchronous: true,
      });

      const {response: fileData} = await airgram.api.readFilePart({
        fileId,
        offset: 0,
        count: 0,
      });

      file.dataUrl = await blobToDataURL(fileData.data);

      store.stores.files.files.push(file);
    }

    return file;
  },

  async getChatHistory(def) {
    return (await airgram.api.getChatHistory(def)).response;
  }
}
